import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, defaultProps } from 'recompose';
import DropdownList from 'react-widgets/lib/DropdownList';
import {
  Button,
  Glyphicon,
  InputGroup,
} from 'react-bootstrap';

import createAdapter from '../../../utils/fuseFilterAdapter';
import LookupResultListItem from '../../lookups/components/LookupResultListItem';
import { querySelector } from '../../../utils';
import createOption from '../../../utils/dropdownListCreateOption';
import CompatLookupResultListItem from '../../lookups/components/CompatLookupResultListItem';

/* eslint-disable */
const propTypes = {
  lease: PropTypes.object,
  wells: PropTypes.array.isRequired,
  value: PropTypes.object,
  lookupJoinType: PropTypes.oneOf(['user_records', 'lookup_records', 'union']),
  createWell: PropTypes.func.isRequired,
  createWellFromLookup: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  data: PropTypes.object,

  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
};
/* eslint-enable */

export class WellInput extends Component {
  constructor(props) {
    super(props);

    this.handleCreate = this.handleCreate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCreateFromLookup = this.handleCreateFromLookup.bind(this);
    this.maybeCreateFromLookup = this.maybeCreateFromLookup.bind(this);
  }

  async handleCreate(name) {
    const { onChange } = this.props;
    const leaseId = this.props.lease.user_id;
    const variables = {
      input: {
        name,
        lease_id: leaseId,
      },
    };
    try {
      const result = await this.props.createWell({ variables });
      await this.props.data.refetch();
      const lease = result.data.well_create;
      onChange(lease);
    } catch (e) {
      console.log('error', e);
    }
  }

  async handleCreateFromLookup(lookupId) {
    const variables = {
      input: {
        well_lookup_id: lookupId,
      },
    };

    const result = await this.props.createWellFromLookup({ variables });
    await this.props.data.refetch();
    return result.data.lookup_result;
  }

  async maybeCreateFromLookup(maybeLookup) {
    if (!maybeLookup) {
      return null;
    }

    if (maybeLookup.lookupStatus === 'reference') {
      const newRecord = await this.handleCreateFromLookup(maybeLookup.lookup_id);
      return newRecord;
    }

    return maybeLookup;
  }

  async handleChange(data) {
    const record = await this.maybeCreateFromLookup(data);

    this.props.onChange(record);
  }

  render() {
    const {
      wells, value, disabled, onBlur, onFocus, lease, lookupJoinType,
    } = this.props;

    const filter = createAdapter(wells);
    const itemComponent = lookupJoinType === 'union' ? LookupResultListItem : CompatLookupResultListItem;

    /* For redux-form, setting field as required if operator has been cleared */
    if (!lease) {
      /*
      * FIXME:
      * Warning: Cannot update during an existing state transition (such as within `render` or
      * another component's constructor). Render methods should be a pure function of props and
      * state; constructor side-effects are an anti-pattern, but can be moved to
      * `componentWillMount`.
      */
      onBlur();
      this.handleChange(null);
    }

    return (
      <div>
        <InputGroup>
          <DropdownList
            inputProps={{
              className: 'select',
            }}
            filter={filter}
            allowCreate="onFilter"
            data={wells}
            value={value}
            valueField="id"
            textField="name"
            itemComponent={itemComponent}
            onChange={this.handleChange}
            disabled={disabled}
            onCreate={(name) => { return this.handleCreate(name); }}
            onFocus={onFocus}
            messages={{ createOption }}
            onBlur={() => { onBlur(); }}
          />
          <InputGroup.Button>
            <Button
              name="cancel"
              disabled={!value}
              /* calling onBlur event to change touched flag to show error if need be */
              onClick={() => {
                onBlur();
                this.handleChange(null);
              }}
            >
              <Glyphicon glyph="remove" />
            </Button>
          </InputGroup.Button>
        </InputGroup>
      </div>
    );
  }
}

WellInput.propTypes = propTypes;

export const WellInputWellFragment = gql`
  fragment WellInputWell on WellLookupResult {
    id
    user_id
    lookup_id
    name
    lookupStatus: lookup_status
    api_number
  }
`;

const GetAllWellsQuery = gql`
  query GetAllWells($leaseId: Int!, $lookupJoinType: LookupJoinTypes!) {
    all_wells: lookup_wells(lease_id: $leaseId, lookup_query: {join_type: $lookupJoinType}) {
      edges {
        node {
         ...WellInputWell
        }
      }
    }
  }
  ${WellInputWellFragment}
`;

const CreateWellMutation = gql`
  mutation CreateWellMutation($input: WellCreateFromNameInput!) {
    well_create: well_create_from_name(input: $input) {
      ...WellInputWell
    }
  }
  ${WellInputWellFragment}
`;

const CreateWellFromLookupMutation = gql`
  mutation WellCreateFromLookup($input: WellCreateFromLookupInput!) {
    lookup_result: well_create_from_lookup(input: $input) {
      ...WellInputWell
    }
  }
  ${WellInputWellFragment}
`;

export const marshallData = ({ data, ownProps }) => {
  const wells = querySelector(data, '$.all_wells.edges[*].node', []);
  return {
    ...ownProps,
    data,
    wells,
  };
};

const queryVariables = (props) => {
  const leaseId = (props.lease) && props.lease.user_id;
  const { lookupJoinType } = props;
  return {
    variables: {
      leaseId,
      lookupJoinType,
    },
  };
};

const withData = graphql(GetAllWellsQuery, {
  props: marshallData,
  options: queryVariables,
});

const withCreate = graphql(CreateWellMutation, { name: 'createWell' });

const withCreateFromLookup = graphql(CreateWellFromLookupMutation, { name: 'createWellFromLookup' });

const enhance = compose(
  defaultProps({ lookupJoinType: 'user_records' }),
  withData,
  withCreate,
  withCreateFromLookup,
);

export default enhance(WellInput);
